import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
/* eslint-disable no-alert, no-console */
// prettier-disable
const routes = [
  {
    path: '/',
    props: true,
    name: 'Offer',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "offer" */ '../views/Offer.vue'), // prettier-ignore
  },
  {
    path: '/pageview',
    props: true,
    name: 'PageView',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "pageview" */ '../views/PageView.vue'), // prettier-ignore
  },
  {
    path: '/checkout',
    props: true,
    name: 'Checkout',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue'),
  },
  {
    path: '/my-profile',
    props: true,
    name: 'My Profile',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "my-profile" */ '../views/myAccount/MyProfile.vue'),
  },
  {
    path: '/amp-login',
    props: true,
    name: 'Amp Login',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "amp-login" */ '../views/amp/AmpLogin.vue'),
  },
  {
    path: '/amp-subscribe',
    props: true,
    name: 'Amp Subscribe',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "amp-subscribe" */ '../views/amp/AmpSubscribe.vue'),
  },
  {
    path: '/redeem-access',
    props: true,
    name: 'Redeem Access',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "redeem-access" */ '../views/RedeemAccess.vue'), // prettier-ignore
  },
  {
    path: '/license-form',
    props: true,
    name: 'License Form',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "license-form" */ '../views/LicenseForm.vue'), // prettier-ignore
  },
  {
    path: '/my-profile/subscriptions/active',
    props: true,
    name: 'Active Subscriptions',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "active-subscriptions" */ '../views/myAccount/porta/subscriptions/ActiveSubscriptions.vue'),
  },
  {
    path: '/my-profile/subscriptions/expired',
    props: true,
    name: 'Expired Subscriptions',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "expired-subscriptions" */ '../views/myAccount/porta/subscriptions/ExpiredSubscriptions.vue'),
  },
  {
    path: '/my-profile/payments/info',
    props: true,
    name: 'Payment Info',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "payment-info" */ '../views/myAccount/porta/payments/PaymentInfo.vue'),
  },
  {
    path: '/my-profile/payments/history',
    props: true,
    name: 'Payment History',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "payment-history" */ '../views/myAccount/porta/payments/PaymentHistory.vue'),
  },
  {
    path: '/my-profile/gifts',
    props: true,
    name: 'Gifts',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "gifts" */ '../views/myAccount/porta/gifts/Gifts.vue'),
  },
  {
    path: '/my-profile/vouchers',
    props: true,
    name: 'Vouchers',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "vouchers" */ '../views/myAccount/porta/gifts/Vouchers.vue'),
  },
  {
    path: '/my-profile/external-vouchers',
    props: true,
    name: 'External Vouchers',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "external-vouchers" */ '../views/myAccount/porta/gifts/ExternalVouchers.vue'),
  },
  {
    path: '/my-profile/site-licenses',
    props: true,
    name: 'Site Licenses',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "site-licenses" */ '../views/myAccount/porta/siteLicenses/SiteLicenses.vue'),
  },
  {
    path: '/my-profile/site-license-users',
    props: true,
    name: 'Site License Users',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "site-license-users" */ '../views/myAccount/porta/siteLicenses/SiteLicenseUsers.vue'),
  },
  {
    path: '/admin/checkout/braintree',
    props: true,
    name: 'Admin Braintree Checkout',
    // prettier-ignore
    component: () => import(/* webpackChunkName: "admin-braintree-checkout" */ '../views/admin/checkout/braintree/Checkout.vue'),
  },
];
// prettier-enable
/* eslint-disable no-alert, no-console */

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
